import React from 'react';

export default function RedesContacto({
	register,
	getValues,
	watch,
	append,
	remove,
	errors = {},
	paises = [],
	barrios = [],
	municipiosdto = [],
	parentescos = [],
	tiposDocumentos = []
}) {
	function addRedContacto() {
		append({
			strNombrecompleto: '',
			strTelefonos: '',
			strDireccion: '',
			intIdMunicipio: '',
			intIdvulneracionderechos: '',
			intIdpais: '',
			strOtromunicipio: '',
			intIdparentesco: '',
			intTipodocumento: '',
			strIdcontacto: '',
			intIdbarrio: '',
			strEmail: '',
		});
	}
	
	return (
		<>
			<div className="row">
				<div className="col-md-4">
					<button type="button" className="btn btn-secondary" onClick={() => addRedContacto()}>
						Agregar red de contacto
					</button>
				</div>
			</div>
			{getValues('redesContacto') && getValues('redesContacto').length > 0 && (
				getValues('redesContacto').map((_, i) => {
					const paisSeleccionado = watch ? watch(`redesContacto.${i}.intIdpais`) : getValues(`redesContacto.${i}.intIdpais`);
					const esColombia = paisSeleccionado == 52;
					return (
					<React.Fragment key={_.id ?? i}>
						<div className="row">
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor={`redesContacto[${i}].intTipodocumento`}>Tipo de documento del contacto</label>
									<select id={`redesContacto[${i}].intTipodocumento`} className="form-control" {...register(`redesContacto.${i}.intTipodocumento`, { required: true, valueAsNumber: true })}>
										<option value="">Seleccione...</option>
										{tiposDocumentos.map((option, idx) => (
											<option key={option.id || idx} value={option.id}>{option.tipTipoidentificacion} - {option.tipDescripcion}</option>
										))}
									</select>
								</div>
							</div>
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor={`redesContacto[${i}].strIdcontacto`}>N&uacute;mero de documento del contacto</label>
									<input
										id={`redesContacto[${i}].strIdcontacto`}
										className="form-control"
										{...register(`redesContacto.${i}.strIdcontacto`, { required: true })}
									/>
									{errors.redesContacto?.[i]?.strIdcontacto && (
										<span className="text-danger">Este campo es obligatorio</span>
									)}
								</div>
							</div>
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor={`redesContacto[${i}].strNombrecompleto`}>Nombre completo</label>
									<input
										id={`redesContacto[${i}].strNombrecompleto`}
										className="form-control"
										{...register(`redesContacto.${i}.strNombrecompleto`, { required: true })}
									/>
									{errors.redesContacto?.[i]?.strNombrecompleto && (
										<span className="text-danger">Este campo es obligatorio</span>
									)}
								</div>
							</div>
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor={`redesContacto[${i}].intIdparentesco`}>Parentesco de la víctima</label>
									<select id={`redesContacto[${i}].intIdparentesco`} className="form-control" {...register(`redesContacto.${i}.intIdparentesco`, { required: true, valueAsNumber: true })}>
										<option value="">Seleccione...</option>
										{parentescos.map((option, idx) => (
											<option key={option.id || idx} value={option.id}>{option.parParentesco}</option>
										))}
									</select>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor={`redesContacto[${i}].intIdpais`}>Nacionalidad contacto</label>
									<select id={`redesContacto[${i}].intIdpais`} className="form-control" {...register(`redesContacto.${i}.intIdpais`, { required: true, valueAsNumber: true })}>
										<option value="">Seleccione...</option>
										{paises.map((option, idx) => (
											<option key={option.id || idx} value={option.id}>{option.pais + ' - ' + option.iso}</option>
										))}
									</select>
								</div>
							</div>
							{esColombia ? (
								<div className="col-md-3">
									<div className="form-group">
										<label htmlFor={`redesContacto[${i}].intIdmunicipio`}>Municipio</label>
										<select id={`redesContacto[${i}].intIdmunicipio`} className="form-control" {...register(`redesContacto.${i}.intIdmunicipio`, { valueAsNumber: true })}>
											<option value="">Seleccione...</option>
											{municipiosdto.map((option, idx) => (
												<option key={option.id} value={option.id}>
													{option.mun_municipio}
												</option>
											))}
										</select>
									</div>
								</div>
							) : (
								<div className="col-md-3">
									<div className="form-group">
										<label htmlFor={`redesContacto[${i}].strOtromunicipio`}>Municipio</label>
										<input
											id={`redesContacto[${i}].strOtromunicipio`}
											className="form-control"
											{...register(`redesContacto.${i}.strOtromunicipio`)}
										/>
									</div>
								</div>
							)}
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor={`redesContacto[${i}].intIdbarrio`}>barrio del contacto</label>
									<select id={`redesContacto[${i}].intIdbarrio`} className="form-control" {...register(`redesContacto.${i}.intIdbarrio`, { valueAsNumber: true })}>
										<option value="">Seleccione...</option>
										{barrios.map((option, idx) => (
											<option key={option.id} value={option.id}>
												{option.bar_barrio} - {option.com_comuna}
											</option>
										))}
									</select>
								</div>
							</div>
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor={`redesContacto[${i}].strDireccion`}>Dirección</label>
									<input
										id={`redesContacto[${i}].strDireccion`}
										className="form-control"
										{...register(`redesContacto.${i}.strDireccion`)}
									/>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor={`redesContacto[${i}].strTelefonos`}>Teléfonos</label>
									<input
										id={`redesContacto[${i}].strTelefonos`}
										className="form-control"
										{...register(`redesContacto.${i}.strTelefonos`)}
									/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="form-group">
									<label htmlFor={`redesContacto[${i}].strEmail`}>Correo electr&oacute;nico del contacto</label>
									<input
										id={`redesContacto[${i}].strEmail`}
										className="form-control"
										{...register(`redesContacto.${i}.strEmail`)}
									/>
								</div>
							</div>
							<input type="hidden" {...register(`redesContacto.${i}.id`, { valueAsNumber: true })} />
							<input type="hidden" {...register(`redesContacto.${i}.intIdvulneracionderechos`, { valueAsNumber: true })} />
						</div>
						<div className="row">
							<div className="col-md-2">
								<button type="button" className="btn btn-danger" onClick={() => remove(i)}>
									Borrar
								</button>
							</div>
						</div>
						<hr />
					</React.Fragment>
					);
				})
			)}
		</>
	);
}
